<script setup lang="ts">
import { CollapsibleContent } from "reka-ui"
</script>

<template>
  <CollapsibleContent
    class="SidebarNavigationExpandableItemContent overflow-hidden"
  >
    <div class="mt-0.5 ml-4 flex min-h-0 flex-col gap-0.5 overflow-hidden">
      <slot />
    </div>
  </CollapsibleContent>
</template>

<style scoped>
.SidebarNavigationExpandableItemContent[data-state="open"] {
  animation: sidebar-navigation-expandable-item-down 0.2s ease-out;
}

.SidebarNavigationExpandableItemContent[data-state="closed"] {
  animation: sidebar-navigation-expandable-item-up 0.2s ease-out;
}

@keyframes sidebar-navigation-expandable-item-down {
  from {
    height: 0;
  }

  to {
    height: var(--reka-collapsible-content-height);
  }
}

@keyframes sidebar-navigation-expandable-item-up {
  from {
    height: var(--reka-collapsible-content-height);
  }

  to {
    height: 0;
  }
}
</style>
